
const state = ()=>({
  snackBarState:{
    showSnackbar: false,
    color : '#ff0000',
    textSnackBar: 'متاسفانه تغییرات اعمال نشد ',
    }

})

const mutations = {
  SET_SNACKBAR (state , data){
    Object.assign(state.snackBarState, data);

  }
}
const getters = {
  getSnackbar(state){
    return state.snackBarState
  }
}
const actions = {
  snackBarAction({commit} , snackbarData){
    commit('SET_SNACKBAR' , snackbarData);

  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}
